import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const customConfig = defineConfig({
  globalCss: {
    "::selection": {
      backgroundColor: "#0A3D2E",
      color: "white",
    },
  },
  theme: {
    tokens: {
      fonts: {
        heading: { value: `'Plus Jakarta Sans', system-ui, sans-serif` },
        body:    { value: `'Plus Jakarta Sans', system-ui, sans-serif` },
      },
      colors: {
        // Result brand — deep bottle green
        brand: {
          50:  { value: "#EDFAF3" },
          100: { value: "#D0F2E1" },
          200: { value: "#A3E4C4" },
          300: { value: "#6CCFA0" },
          400: { value: "#3AB67D" },
          500: { value: "#1A9460" },
          600: { value: "#127348" },
          700: { value: "#0C5436" },
          800: { value: "#0A3D2E" }, // PRIMARY
          900: { value: "#062619" },
          950: { value: "#03150E" },
        },
        // Gold accent
        gold: {
          50:  { value: "#FEF9ED" },
          100: { value: "#FDF0CE" },
          200: { value: "#FAE09D" },
          300: { value: "#F7CB64" },
          400: { value: "#F4B535" },
          500: { value: "#E09B12" },
          600: { value: "#C8820A" }, // PRIMARY ACCENT
          700: { value: "#A56508" },
          800: { value: "#7D4C07" },
          900: { value: "#5A3606" },
        },
        // Warm neutrals — not cold slate
        gray: {
          50:  { value: "#F7F4EE" }, // parchment background
          100: { value: "#EDE8DE" },
          200: { value: "#DDD5C5" },
          300: { value: "#C5BAA5" },
          400: { value: "#A89A84" },
          500: { value: "#8C7E6A" },
          600: { value: "#6E6252" },
          700: { value: "#5C5040" },
          800: { value: "#3D3428" },
          900: { value: "#1A1208" }, // warm near-black
          950: { value: "#0D0904" },
        },
      },
      spacing: {
        xs:  { value: "0.5rem" },
        sm:  { value: "0.75rem" },
        md:  { value: "1rem" },
        lg:  { value: "1.5rem" },
        xl:  { value: "2rem" },
        "2xl":{ value: "3rem" },
      },
      radii: {
        sm:   { value: "0.375rem" },
        md:   { value: "0.5rem" },
        lg:   { value: "0.75rem" },
        xl:   { value: "1rem" },
        "2xl":{ value: "1.5rem" },
        full: { value: "9999px" },
      },
    },
    semanticTokens: {
      colors: {
        brand: {
          solid:     { value: "{colors.brand.800}" },
          contrast:  { value: "{colors.brand.50}" },
          fg:        { value: "{colors.brand.700}" },
          muted:     { value: "{colors.brand.100}" },
          subtle:    { value: "{colors.brand.200}" },
          emphasized:{ value: "{colors.brand.300}" },
          focusRing: { value: "{colors.brand.600}" },
        },
        gold: {
          solid:     { value: "{colors.gold.600}" },
          contrast:  { value: "{colors.gold.50}" },
          fg:        { value: "{colors.gold.700}" },
          muted:     { value: "{colors.gold.100}" },
          subtle:    { value: "{colors.gold.200}" },
          emphasized:{ value: "{colors.gold.300}" },
          focusRing: { value: "{colors.gold.500}" },
        },
      },
    },
  },
});

export const system = createSystem(defaultConfig, customConfig);
